import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  ViewChild,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { CONSTANTS_DETAILS } from '../../models/constants';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../../../modules/shared/shared.module';
import { AuthService } from '../../../services/auth/auth.service';
import { filter } from 'rxjs';
import { RolesPrivilege } from '../../models/roles-interface';
@Component({
  selector: 'app-side-nav',
  imports: [
    SharedModule,
    RouterOutlet,
    MatSidenav,
    MatSidenavModule,
    MatListModule,
    RouterLink,
    RouterLinkActive,
    NgOptimizedImage,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
  ],
  standalone: true,
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavComponent {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  public isSidebarCollapsed: boolean = true;
  public SIDENAV_ITEMS = structuredClone(CONSTANTS_DETAILS.APP_MENUS);
  expandedMenus: boolean[] = [];
  public activeParentIndex = signal<number | null>(null);
  readonly _authService = inject(AuthService);

  constructor(private _router: Router) {
    // Set active parent index on initial load and on navigation
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActiveMenuByRoute(event.urlAfterRedirects);
      }
    });
    // Initial load
    this._authService.userRoles
      .pipe(
        filter(
          (roles): roles is RolesPrivilege =>
            !!roles && Object.keys(roles).length > 0,
        ),
      )
      .subscribe((roles) => {
        if (!Array.isArray(roles) && roles.privilegeIdentifiers) {
          if (!roles.privilegeIdentifiers.includes('SETNG_MNG_APPROVERS')) {
            this.SIDENAV_ITEMS.forEach((item) => {
              if (item.label === 'settings' && Array.isArray(item.children)) {
                item.children = item.children.filter(
                  (child) => child.label !== 'Manage Approvers',
                );
              }
            });
          } else {
            this.SIDENAV_ITEMS = structuredClone(CONSTANTS_DETAILS.APP_MENUS);
          }
        }
      });
    this.setActiveMenuByRoute(this._router.url);
  }

  /**
   * Toggles the sidebar state between collapsed and expanded.
   * This method is called when the user clicks on the toggle button.
   *
   * @memberof SideNavComponent
   */
  public async toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    if (this.isSidebarCollapsed) {
      this.expandedMenus = [];
    }
  }
  /**
   * toggles the expansion state of a specific menu.
   * @param index
   */
  toggleMenuExpansion(index: number) {
    this.expandedMenus[index] = !this.expandedMenus[index];
  }
  /**
   * sets the active state of a specific menu.
   * @param currentUrl
   */
  private setActiveMenuByRoute(currentUrl: string) {
    for (let i = 0; i < this.SIDENAV_ITEMS.length; i++) {
      const item = this.SIDENAV_ITEMS[i];
      if (item.link && currentUrl.startsWith(item.link)) {
        this.activeParentIndex.set(i);
        return;
      }
      if (item.children) {
        for (const child of item.children) {
          if (child.link && currentUrl.startsWith(child.link)) {
            this.activeParentIndex.set(i);
            return;
          }
        }
      }
    }
    this.activeParentIndex.set(null);
  }
}
